import { Effect, Reducer } from '@umijs/max';

import { getLoanTypes } from '@/services/loans.service';

import { LoanType } from '@/interfaces/loans';

export interface ModelType {
  namespace: string;
  state: { loanTypes: LoanType[] };
  effects: {
    fetchData: Effect;
  };
  reducers: {
    setData: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'loansList',

  state: {
    loanTypes: [],
  },

  effects: {
    *fetchData({ payload }, { call, put, all }) {
      const [loanTypes] = yield all([call(getLoanTypes, payload)]);
      yield put({
        type: 'setData',
        payload: { loanTypes: loanTypes.data },
      });
    },
  },

  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
